/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/angular';
import {
    DegreeProgrammeAttainment,
    DegreeProgrammeAttainmentWorkflow,
    Module,
    ModuleAttainment,
    OtmId,
    Plan,
} from 'common-typescript/types';

@Component({
    selector: 'app-student-module-info-modal-graduation-info',
    templateUrl: './student-module-info-modal-graduation-info.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StudentModuleInfoModalGraduationInfoComponent {
    @Input() module: Module;
    @Input() plan: Plan;
    @Input() organisationId: OtmId;
    @Input() selectedModuleAttainment: ModuleAttainment | DegreeProgrammeAttainment;
    @Input() degreeProgrammeAttainmentWorkflow: DegreeProgrammeAttainmentWorkflow;
    @Input() canApplyForGraduation: boolean;
    @Output() closeModal = new EventEmitter<void>();

    private readonly stateService = inject(StateService);

    openGraduationWizard(): void {
        this.closeModal.emit();
        this.stateService.go('student.logged-in.graduation-wizard', {
            planId: this.plan.id,
            degreeProgrammeId: this.module.id,
        });
    }
}
